module.exports = __webpack_public_path__ + "img/infinity8_icon.22ac0acf.png";